import { useEffect, useState } from 'react';

function parseAsUtc(value: string): number {
  const hasTimezone = /Z|[+-]\d{2}:?\d{2}$/.test(value);
  return new Date(hasTimezone ? value : `${value}Z`).getTime();
}

function formatElapsed(since: string): string {
  const diff = Math.max(0, Math.floor((Date.now() - parseAsUtc(since)) / 1000));
  const h = Math.floor(diff / 3600);
  const m = Math.floor((diff % 3600) / 60);
  const s = diff % 60;

  if (h > 0) return `${h}h ${m}m ${s}s`;
  if (m > 0) return `${m}m ${s}s`;
  return `${s}s`;
}

interface ElapsedTimeProps {
  since: string;
}

function ElapsedTime({ since }: ElapsedTimeProps) {
  const [display, setDisplay] = useState(() => formatElapsed(since));

  useEffect(() => {
    const interval = setInterval(() => {
      setDisplay(formatElapsed(since));
    }, 1000);

    return () => clearInterval(interval);
  }, [since]);

  return <>{display}</>;
}

export default ElapsedTime;
